(function() {
  'use strict';

  function updateDetails(variantId) {
    var dataEl = document.getElementById('zicoto-variant-data');
    if (!dataEl) return;
    var allVariants;
    try { allVariants = JSON.parse(dataEl.textContent); } catch(e) { return; }
    var v = allVariants[String(variantId)];
    if (!v) return;

    var skuEl  = document.getElementById('details-sku');
    var asinEl = document.getElementById('details-asin');
    var gtinEl = document.getElementById('details-gtin');

    if (skuEl)  skuEl.innerHTML  = v.sku  ? '<b>SKU:</b> '  + v.sku  : '';
    if (asinEl) asinEl.innerHTML = v.asin ? '<b>Parent ASIN:</b> ' + v.asin : '';
    if (gtinEl) gtinEl.innerHTML = v.gtin ? '<b>GTIN:</b> ' + v.gtin : '';
  }

  function init() {
    // Hook into Dawn's pubsub
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        if (event && event.data && event.data.variant) {
          updateDetails(event.data.variant.id);
        }
      });
    } else {
      // Retry until pubsub is available
      setTimeout(init, 300);
      return;
    }

    // Also poll URL as fallback
    var lastId = new URLSearchParams(window.location.search).get('variant');
    setInterval(function() {
      var id = new URLSearchParams(window.location.search).get('variant');
      if (id && id !== lastId) { lastId = id; updateDetails(id); }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
